import { Component, OnInit } from "@angular/core";
import { NavParams, ModalController } from "@ionic/angular";
import { AccessReport } from "src/app/interfaces/access";
import { FunctionsService } from "src/app/services/functions/functions.service";
import * as XLSX from "xlsx";
import { Homeowner, Subscription } from "src/app/interfaces/user";
import { LoadingService } from "src/app/services/loading/loading.service";
import { QueryRecord } from "src/app/interfaces/helpers";
import {
  Checkout,
  PatrolRecord,
  SalesReport,
  SubscriptionSales,
  TicketDiscount,
} from "src/app/interfaces/installation";
import { Contact } from "src/app/interfaces/contact";
import { TicketRecord } from "src/app/interfaces/support";

@Component({
  selector: "app-report-zoom",
  templateUrl: "./report-zoom.page.html",
  styleUrls: ["./report-zoom.page.scss"],
})
export class ReportZoomPage implements OnInit {
  today = new Date();
  fileName = "";
  access: AccessReport[];
  patrols: PatrolRecord[] = [];
  subscriptions: Subscription[];
  homeowners: Homeowner[];
  queries: QueryRecord[];
  checkouts: Checkout[];
  discounts: TicketDiscount[];
  sales: SubscriptionSales[];
  contacts: Contact[];
  records: TicketRecord;
  managers = [];
  tableHeaders = [];
  type: string;
  accessHeaders = [
    "ID",
    "Privada",
    "Área",
    "Terminal",
    "Destino",
    "Creación",
    "Tipo",
    "Usuario",
    "Status",
  ];
  subscriptionHeaders = [
    "Usuario",
    "Lugar",
    "Propiedad",
    "Inició",
    "Termina",
    "Tipo",
    "Precio",
    "Creación",
    "Creada por",
    "Vendedor",
    "Tipo de pago",
  ];
  residentHeaders = ["Usuario", "Dirección", "Vencimiento", "Status"];
  queryHeaders = ["Consulta", "Tamaño", "Fecha", "Usuario"];
  checkoutHeaders = [
    "Fecha de Inicio",
    "Fecha de Retiro",
    "Operador",
    "Total",
    "No. de Tickets",
  ];
  discountHeaders = ["Asociado", "Aplicado por", "Cantidad", "Ticket"];
  salesHeaders = [
    "Vendedor",
    "Demos",
    "Suscripciones",
    "Total vendido",
    "Comisión",
  ];
  contactsHeaders = [
    "Nombre",
    "Apellidos",
    "Telefono",
    "Nombre completo",
    "Email",
    "Creación",
  ];
  patrolsHeaders = [
    "Zona",
    "Estatus",
    "Dirección",
    "Guardia",
    "Fecha",
    "Notas",
  ];
  recordsHeaders = ["Agente", "Actividad", "Fecha"];
  managersHeaders = ["Instalación", "Usuario", "Email"];

  constructor(
    private navParams: NavParams,
    public modalCtrl: ModalController,
    public funcServ: FunctionsService,
    private loadingServ: LoadingService,
  ) {}

  ngOnInit() {
    this.type = this.navParams.get("type");
    // console.log(this.type);

    this.fileName = this.funcServ.getExcelFilename(this.type);
    switch (this.type) {
      case "accesos":
        this.tableHeaders = this.accessHeaders;
        this.access = this.navParams.get("rows");
        break;
      case "records":
        this.tableHeaders = this.recordsHeaders;
        this.records = this.navParams.get("rows");
        break;
      case "patrols":
        this.tableHeaders = this.patrolsHeaders;
        this.patrols = this.navParams.get("rows");
        break;
      case "suscripciones":
        this.tableHeaders = this.subscriptionHeaders;
        this.subscriptions = this.navParams.get("rows");
        break;
      case "residentes":
        this.tableHeaders = this.residentHeaders;
        this.homeowners = this.navParams.get("rows");
        break;
      case "consultas":
        this.tableHeaders = this.queryHeaders;
        this.queries = this.navParams.get("rows");
        break;
      case "retiros":
        this.tableHeaders = this.checkoutHeaders;
        this.checkouts = this.navParams.get("rows");
        break;
      case "descuentos":
        this.tableHeaders = this.discountHeaders;
        this.discounts = this.navParams.get("rows");
        break;
      case "ventas_suscripciones":
        this.tableHeaders = this.salesHeaders;
        this.sales = this.navParams.get("rows");
        break;
      case "contacts":
        this.tableHeaders = this.contactsHeaders;
        this.contacts = this.navParams.get("rows");
        break;
      case "managers":
        this.tableHeaders = this.managersHeaders;
        this.managers = this.navParams.get("rows");
        break;
      default:
        this.tableHeaders = [];
        break;
    }
    console.log(this.fileName);
    console.log(this.tableHeaders);
    console.log(this.navParams.get("rows"));
    this.print();
  }

  print() {
    this.loadingServ.present("").then(() => {
      /* table id is passed over here */
      const element = document.getElementById("excel-table");
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Reporte");

      /* save to file */
      XLSX.writeFile(wb, this.fileName);
      this.loadingServ.dismiss().then(() => {
        this.modalCtrl.dismiss();
      });
    });
  }

  // print() {
  //   let data = document.getElementById('table');
  //   html2canvas(data).then(canvas => {
  //     const contentDataURL = canvas.toDataURL('image/png')
  //     //let pdf = new jspdf('l', 'cm', 'a4'); //Generates PDF in landscape mode
  //      let pdf: any = new jspdf('p', 'cm', 'a4'); //Generates PDF in portrait mode
  //     pdf.addImage(contentDataURL, 'PNG', 0, 0, 29.7, 21.0);
  //     pdf.save('Filename.pdf');
  //   });
  // }

  // print() {
  //   const element = document.getElementById('html2canvas');
  //   const targetElement = document.getElementById('reportCanvas').cloneNode(true);
  //   element.appendChild(targetElement);
  //   this.pdfServ.html2canvas(element.firstChild).then((img) => {
  //     this.img = img;
  //     element.firstChild.remove();
  //   }).catch((res) => {
  //     // console.log(res);
  //   });
  //   let pdf: any = new jspdf('p', 'cm', 'a4');
  //   pdf.addImage(this.img, 'PNG', 0, 0, 29.7, 21.0);
  //   pdf.save('reporte.pdf')
  // }

  // print() {
  //   const div = document.getElementById("table");
  //   const options = { background: "white", height: div.clientWidth, width: div.clientHeight };
  //   domtoimage.toPng(div, options).then((dataUrl)=> {
  //     // console.log(dataUrl);

  //     //Initialize JSPDF
  //     var doc = new jspdf("p","cm","a4");
  //     //Add image Url to PDF
  //     doc.addImage(dataUrl, 'PNG', 20, 20, 240, 180);

  //     let pdfOutput = doc.output();
  //     // using ArrayBuffer will allow you to put image inside PDF
  //     let buffer = new ArrayBuffer(pdfOutput.length);
  //     let array = new Uint8Array(buffer);
  //     for (var i = 0; i < pdfOutput.length; i++) {
  //         array[i] = pdfOutput.charCodeAt(i);
  //     }
  //     doc.save('reporte.pdf')
  //   });
  // }
}
